import { defineStore } from "pinia";
import { piniaPlugin } from "../../index";

export const useMultiSelect = defineStore("multiSelect", {
    state: () => ({
        store: piniaPlugin(),
        selectedItems: [],
        isShowActionButton: false,
        showTopProgress: false,
        toast: {
            isSuccess: false,
            successMsg: null,
            isToastMessage: false,
        },
    }),
    getters: {},
    actions: {
        multiSelectFileFolder(type) {
            if (type === "selectAll") {
                const checkboxes = document.querySelectorAll(".multipleSelect");
                checkboxes.forEach((checkbox) => {
                    checkbox.checked = true;
                    checkbox.dispatchEvent(new Event("change"));
                });
            } else {
                const checkboxes = document.querySelectorAll(".multipleSelect");
                checkboxes.forEach((checkbox) => {
                    checkbox.checked = false;
                    checkbox.dispatchEvent(new Event("change"));
                });
            }
        },
        resetOnComponentUpdate() {
            this.isShowActionButton = false;
            this.selectedItems = [];
            this.store.useMoveStore.hideMoveModal();
        },
    },
});